import Vue from 'vue';

type State = {
  is補助科目別貸借対照表: boolean;
};

const state = Vue.observable<State>({
  is補助科目別貸借対照表: false,
});

export default Vue.extend({
  name: 'M計画貸借対照表Mixin',

  computed: {
    is補助科目別貸借対照表(): boolean {
      return state.is補助科目別貸借対照表;
    },
  },

  methods: {
    inactivate補助科目別貸借対照表(): void {
      state.is補助科目別貸借対照表 = false;
    },
    toggle補助科目別貸借対照表(): void {
      state.is補助科目別貸借対照表 = !state.is補助科目別貸借対照表;
    },
  },
});
